module.exports = __webpack_public_path__ + "static/Synbitech_speaker announcement-5d1e5e81a1a58ba24ed558f8795b357a.jpg";